import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import React, { FC } from 'react';

interface Props {
  image: IGatsbyImageData | string;
  alt: string;
}

const Image: FC<Props> = ({ image, alt }) => {
  if (typeof image === 'string') {
    return <img src={image} style={{ width: '100%' }} alt={alt} />;
  }

  return <GatsbyImage image={image} alt={alt} />;
};

export default Image;
